import { useAuth } from "@/lib/auth";
import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { LogOut, Car, ChevronRight, Shield, HelpCircle, ClipboardList } from "lucide-react";

export default function DriverProfile() {
  const { user, logout } = useAuth();
  const nav = useNavigate();
  const [vehicle, setVehicle] = useState(null);

  useEffect(() => {
    if (user?.assigned_vehicle_id) {
      api.get("/vehicles").then((r) => {
        const v = r.data?.find((x) => x.id === user.assigned_vehicle_id);
        setVehicle(v);
      });
    }
  }, [user]);

  return (
    <div className="min-h-screen bg-slate-50">
      <div className="bg-white pt-safe pt-8 pb-6 px-5 border-b border-slate-100">
        <div className="flex items-center gap-4">
          <div className="w-20 h-20 rounded-2xl bg-gradient-to-br from-primary to-primary-700 text-white flex items-center justify-center font-display font-bold text-3xl">
            {user?.name?.charAt(0)}
          </div>
          <div>
            <h1 className="font-display font-bold text-2xl text-slate-900">{user?.name}</h1>
            <p className="text-xs text-slate-400 font-mono mt-1">{user?.enec_id} · Driver</p>
            <p className="text-xs text-slate-500">{user?.phone}</p>
          </div>
        </div>
      </div>

      <div className="px-5 py-5 space-y-4 pb-32">
        {vehicle && (
          <div className="bg-gradient-to-br from-primary to-primary-700 text-white rounded-2xl p-5 relative overflow-hidden">
            <div className="absolute -right-8 -top-8 w-32 h-32 bg-white/10 rounded-full" />
            <Car size={28} />
            <p className="text-xs uppercase tracking-widest text-white/70 font-bold mt-2">Assigned vehicle</p>
            <p className="font-display font-bold text-2xl mt-1">{vehicle.make} {vehicle.model}</p>
            <p className="text-sm text-white/80">{vehicle.year} · {vehicle.color}</p>
            <p className="font-mono text-sm mt-3 bg-white/20 inline-block px-3 py-1 rounded-lg">{vehicle.plate_number}</p>
          </div>
        )}

        <div className="bg-white rounded-2xl border border-slate-200 overflow-hidden">
          {[
            { icon: ClipboardList, label: "Shift schedule", testId: "p-shift" },
            { icon: Shield, label: "Documents & license", testId: "p-docs" },
            { icon: HelpCircle, label: "Help & emergency", testId: "p-help" },
          ].map((it, idx) => (
            <button key={it.label} data-testid={it.testId} className={`w-full flex items-center gap-3 px-4 py-4 hover:bg-slate-50 transition-colors text-left ${idx > 0 ? "border-t border-slate-100" : ""}`}>
              <div className="w-9 h-9 rounded-lg bg-slate-100 text-slate-700 flex items-center justify-center">
                <it.icon size={18} />
              </div>
              <span className="flex-1 font-medium text-slate-800 text-sm">{it.label}</span>
              <ChevronRight size={16} className="text-slate-300" />
            </button>
          ))}
        </div>

        <button
          data-testid="driver-logout"
          onClick={() => { logout(); nav("/login/driver", { replace: true }); }}
          className="w-full h-12 rounded-xl bg-rose-50 hover:bg-rose-100 text-rose-600 font-semibold flex items-center justify-center gap-2"
        >
          <LogOut size={18} /> Sign out
        </button>
      </div>
    </div>
  );
}
